/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  AssignUserToFlatRequest,
  FlatDocumentGenericApiResponse,
  FlatListOrder,
  FlatNoteRequest,
  GraphTimeSpan,
  IgnoreFlatRequest,
  LogOverviewDtoGenericApiResponse,
  PageUrlDocumentListGenericApiResponse,
  Severity,
  StarFlatRequest,
  StringInt64DictionaryGenericApiResponse,
  StringWebDeviceInfoDictionaryGenericApiResponse,
  StructuralDataResponseGenericApiResponse,
  SuccessfullApiResponse,
} from '../models';
import {
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    AssignUserToFlatRequestFromJSON,
    AssignUserToFlatRequestToJSON,
    FlatDocumentGenericApiResponseFromJSON,
    FlatDocumentGenericApiResponseToJSON,
    FlatListOrderFromJSON,
    FlatListOrderToJSON,
    FlatNoteRequestFromJSON,
    FlatNoteRequestToJSON,
    GraphTimeSpanFromJSON,
    GraphTimeSpanToJSON,
    IgnoreFlatRequestFromJSON,
    IgnoreFlatRequestToJSON,
    LogOverviewDtoGenericApiResponseFromJSON,
    LogOverviewDtoGenericApiResponseToJSON,
    PageUrlDocumentListGenericApiResponseFromJSON,
    PageUrlDocumentListGenericApiResponseToJSON,
    SeverityFromJSON,
    SeverityToJSON,
    StarFlatRequestFromJSON,
    StarFlatRequestToJSON,
    StringInt64DictionaryGenericApiResponseFromJSON,
    StringInt64DictionaryGenericApiResponseToJSON,
    StringWebDeviceInfoDictionaryGenericApiResponseFromJSON,
    StringWebDeviceInfoDictionaryGenericApiResponseToJSON,
    StructuralDataResponseGenericApiResponseFromJSON,
    StructuralDataResponseGenericApiResponseToJSON,
    SuccessfullApiResponseFromJSON,
    SuccessfullApiResponseToJSON,
} from '../models';

export interface ApiFlatsAssignPutRequest {
    assignUserToFlatRequest?: AssignUserToFlatRequest;
}

export interface ApiFlatsAssignedGetRequest {
    logId: string;
    page: number;
    limit?: number;
    orderBy?: FlatListOrder;
    graphTimeSpan?: GraphTimeSpan;
    starred?: boolean;
    showIgnored?: boolean;
    assignedTo?: string;
    searchFirstSeenFrom?: Date;
    searchFirstSeenTo?: Date;
    searchLastSeenFrom?: Date;
    searchLastSeenTo?: Date;
    searchSeverities?: Array<Severity>;
    searchSearchValue?: string;
    searchStructuralDataFilters?: Array<string>;
    apiKey?: string;
}

export interface ApiFlatsDeleteRequest {
    logId: string;
    page: number;
    limit?: number;
    orderBy?: FlatListOrder;
    graphTimeSpan?: GraphTimeSpan;
    starred?: boolean;
    showIgnored?: boolean;
    assignedTo?: string;
    searchFirstSeenFrom?: Date;
    searchFirstSeenTo?: Date;
    searchLastSeenFrom?: Date;
    searchLastSeenTo?: Date;
    searchSeverities?: Array<Severity>;
    searchSearchValue?: string;
    searchStructuralDataFilters?: Array<string>;
    apiKey?: string;
}

export interface ApiFlatsIgnoredPutRequest {
    ignoreFlatRequest?: IgnoreFlatRequest;
}

export interface ApiFlatsLogIdFlatIdDeleteRequest {
    logId: string;
    flatId: string;
}

export interface ApiFlatsLogIdFlatIdDeviceinfoGetRequest {
    logId: string;
    flatId: string;
}

export interface ApiFlatsLogIdFlatIdGetRequest {
    logId: string;
    flatId: string;
}

export interface ApiFlatsLogIdFlatIdPageurlsGetRequest {
    logId: string;
    flatId: string;
    page?: number;
}

export interface ApiFlatsLogIdFlatIdStatsGetRequest {
    logId: string;
    flatId: string;
}

export interface ApiFlatsLogIdFlatIdStructuraldataGetRequest {
    logId: string;
    flatId: string;
    page?: number;
    limit?: number;
    createdFrom?: Date;
    createdTo?: Date;
    filters?: Array<string>;
}

export interface ApiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGetRequest {
    logId: string;
    flatId: string;
    structuralDataId: string;
    fieldName: string;
}

export interface ApiFlatsNotePutRequest {
    flatNoteRequest?: FlatNoteRequest;
}

export interface ApiFlatsStarredGetRequest {
    logId: string;
    page: number;
    limit?: number;
    orderBy?: FlatListOrder;
    graphTimeSpan?: GraphTimeSpan;
    starred?: boolean;
    showIgnored?: boolean;
    assignedTo?: string;
    searchFirstSeenFrom?: Date;
    searchFirstSeenTo?: Date;
    searchLastSeenFrom?: Date;
    searchLastSeenTo?: Date;
    searchSeverities?: Array<Severity>;
    searchSearchValue?: string;
    searchStructuralDataFilters?: Array<string>;
    apiKey?: string;
}

export interface ApiFlatsStarredPutRequest {
    starFlatRequest?: StarFlatRequest;
}

/**
 * 
 */
export class FlatsApi extends runtime.BaseAPI {

    /**
     */
    async apiFlatsAssignPutRaw(requestParameters: ApiFlatsAssignPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Flats/assign`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignUserToFlatRequestToJSON(requestParameters.assignUserToFlatRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsAssignPut(requestParameters: ApiFlatsAssignPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsAssignPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsAssignedGetRaw(requestParameters: ApiFlatsAssignedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogOverviewDtoGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsAssignedGet.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling apiFlatsAssignedGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.logId !== undefined) {
            queryParameters['LogId'] = requestParameters.logId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['OrderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        if (requestParameters.starred !== undefined) {
            queryParameters['Starred'] = requestParameters.starred;
        }

        if (requestParameters.showIgnored !== undefined) {
            queryParameters['ShowIgnored'] = requestParameters.showIgnored;
        }

        if (requestParameters.assignedTo !== undefined) {
            queryParameters['AssignedTo'] = requestParameters.assignedTo;
        }

        if (requestParameters.searchFirstSeenFrom !== undefined) {
            queryParameters['Search.FirstSeenFrom'] = (requestParameters.searchFirstSeenFrom as any).toISOString();
        }

        if (requestParameters.searchFirstSeenTo !== undefined) {
            queryParameters['Search.FirstSeenTo'] = (requestParameters.searchFirstSeenTo as any).toISOString();
        }

        if (requestParameters.searchLastSeenFrom !== undefined) {
            queryParameters['Search.LastSeenFrom'] = (requestParameters.searchLastSeenFrom as any).toISOString();
        }

        if (requestParameters.searchLastSeenTo !== undefined) {
            queryParameters['Search.LastSeenTo'] = (requestParameters.searchLastSeenTo as any).toISOString();
        }

        if (requestParameters.searchSeverities) {
            queryParameters['Search.Severities'] = requestParameters.searchSeverities;
        }

        if (requestParameters.searchSearchValue !== undefined) {
            queryParameters['Search.SearchValue'] = requestParameters.searchSearchValue;
        }

        if (requestParameters.searchStructuralDataFilters) {
            queryParameters['Search.StructuralDataFilters'] = requestParameters.searchStructuralDataFilters;
        }

        if (requestParameters.apiKey !== undefined) {
            queryParameters['ApiKey'] = requestParameters.apiKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/assigned`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogOverviewDtoGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsAssignedGet(requestParameters: ApiFlatsAssignedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogOverviewDtoGenericApiResponse> {
        const response = await this.apiFlatsAssignedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsDeleteRaw(requestParameters: ApiFlatsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsDelete.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling apiFlatsDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.logId !== undefined) {
            queryParameters['LogId'] = requestParameters.logId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['OrderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        if (requestParameters.starred !== undefined) {
            queryParameters['Starred'] = requestParameters.starred;
        }

        if (requestParameters.showIgnored !== undefined) {
            queryParameters['ShowIgnored'] = requestParameters.showIgnored;
        }

        if (requestParameters.assignedTo !== undefined) {
            queryParameters['AssignedTo'] = requestParameters.assignedTo;
        }

        if (requestParameters.searchFirstSeenFrom !== undefined) {
            queryParameters['Search.FirstSeenFrom'] = (requestParameters.searchFirstSeenFrom as any).toISOString();
        }

        if (requestParameters.searchFirstSeenTo !== undefined) {
            queryParameters['Search.FirstSeenTo'] = (requestParameters.searchFirstSeenTo as any).toISOString();
        }

        if (requestParameters.searchLastSeenFrom !== undefined) {
            queryParameters['Search.LastSeenFrom'] = (requestParameters.searchLastSeenFrom as any).toISOString();
        }

        if (requestParameters.searchLastSeenTo !== undefined) {
            queryParameters['Search.LastSeenTo'] = (requestParameters.searchLastSeenTo as any).toISOString();
        }

        if (requestParameters.searchSeverities) {
            queryParameters['Search.Severities'] = requestParameters.searchSeverities;
        }

        if (requestParameters.searchSearchValue !== undefined) {
            queryParameters['Search.SearchValue'] = requestParameters.searchSearchValue;
        }

        if (requestParameters.searchStructuralDataFilters) {
            queryParameters['Search.StructuralDataFilters'] = requestParameters.searchStructuralDataFilters;
        }

        if (requestParameters.apiKey !== undefined) {
            queryParameters['ApiKey'] = requestParameters.apiKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsDelete(requestParameters: ApiFlatsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsIgnoredPutRaw(requestParameters: ApiFlatsIgnoredPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Flats/ignored`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IgnoreFlatRequestToJSON(requestParameters.ignoreFlatRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsIgnoredPut(requestParameters: ApiFlatsIgnoredPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsIgnoredPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdDeleteRaw(requestParameters: ApiFlatsLogIdFlatIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdDelete.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdDelete(requestParameters: ApiFlatsLogIdFlatIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdDeviceinfoGetRaw(requestParameters: ApiFlatsLogIdFlatIdDeviceinfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringWebDeviceInfoDictionaryGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdDeviceinfoGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdDeviceinfoGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}/deviceinfo`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringWebDeviceInfoDictionaryGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdDeviceinfoGet(requestParameters: ApiFlatsLogIdFlatIdDeviceinfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringWebDeviceInfoDictionaryGenericApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdDeviceinfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdGetRaw(requestParameters: ApiFlatsLogIdFlatIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FlatDocumentGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FlatDocumentGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdGet(requestParameters: ApiFlatsLogIdFlatIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FlatDocumentGenericApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdPageurlsGetRaw(requestParameters: ApiFlatsLogIdFlatIdPageurlsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageUrlDocumentListGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdPageurlsGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdPageurlsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}/pageurls`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUrlDocumentListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdPageurlsGet(requestParameters: ApiFlatsLogIdFlatIdPageurlsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageUrlDocumentListGenericApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdPageurlsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdStatsGetRaw(requestParameters: ApiFlatsLogIdFlatIdStatsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringInt64DictionaryGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdStatsGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdStatsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}/stats`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringInt64DictionaryGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdStatsGet(requestParameters: ApiFlatsLogIdFlatIdStatsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringInt64DictionaryGenericApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdStatsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdStructuraldataGetRaw(requestParameters: ApiFlatsLogIdFlatIdStructuraldataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StructuralDataResponseGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.createdFrom !== undefined) {
            queryParameters['createdFrom'] = (requestParameters.createdFrom as any).toISOString();
        }

        if (requestParameters.createdTo !== undefined) {
            queryParameters['createdTo'] = (requestParameters.createdTo as any).toISOString();
        }

        if (requestParameters.filters) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}/structuraldata`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StructuralDataResponseGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsLogIdFlatIdStructuraldataGet(requestParameters: ApiFlatsLogIdFlatIdStructuraldataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StructuralDataResponseGenericApiResponse> {
        const response = await this.apiFlatsLogIdFlatIdStructuraldataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGetRaw(requestParameters: ApiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGet.');
        }

        if (requestParameters.flatId === null || requestParameters.flatId === undefined) {
            throw new runtime.RequiredError('flatId','Required parameter requestParameters.flatId was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGet.');
        }

        if (requestParameters.structuralDataId === null || requestParameters.structuralDataId === undefined) {
            throw new runtime.RequiredError('structuralDataId','Required parameter requestParameters.structuralDataId was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGet.');
        }

        if (requestParameters.fieldName === null || requestParameters.fieldName === undefined) {
            throw new runtime.RequiredError('fieldName','Required parameter requestParameters.fieldName was null or undefined when calling apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/{logId}/{flatId}/structuraldata/{structuralDataId}/{fieldName}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))).replace(`{${"flatId"}}`, encodeURIComponent(String(requestParameters.flatId))).replace(`{${"structuralDataId"}}`, encodeURIComponent(String(requestParameters.structuralDataId))).replace(`{${"fieldName"}}`, encodeURIComponent(String(requestParameters.fieldName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGet(requestParameters: ApiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiFlatsLogIdFlatIdStructuraldataStructuralDataIdFieldNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsNotePutRaw(requestParameters: ApiFlatsNotePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Flats/note`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FlatNoteRequestToJSON(requestParameters.flatNoteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsNotePut(requestParameters: ApiFlatsNotePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsNotePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsStarredGetRaw(requestParameters: ApiFlatsStarredGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogOverviewDtoGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiFlatsStarredGet.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling apiFlatsStarredGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.logId !== undefined) {
            queryParameters['LogId'] = requestParameters.logId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['OrderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        if (requestParameters.starred !== undefined) {
            queryParameters['Starred'] = requestParameters.starred;
        }

        if (requestParameters.showIgnored !== undefined) {
            queryParameters['ShowIgnored'] = requestParameters.showIgnored;
        }

        if (requestParameters.assignedTo !== undefined) {
            queryParameters['AssignedTo'] = requestParameters.assignedTo;
        }

        if (requestParameters.searchFirstSeenFrom !== undefined) {
            queryParameters['Search.FirstSeenFrom'] = (requestParameters.searchFirstSeenFrom as any).toISOString();
        }

        if (requestParameters.searchFirstSeenTo !== undefined) {
            queryParameters['Search.FirstSeenTo'] = (requestParameters.searchFirstSeenTo as any).toISOString();
        }

        if (requestParameters.searchLastSeenFrom !== undefined) {
            queryParameters['Search.LastSeenFrom'] = (requestParameters.searchLastSeenFrom as any).toISOString();
        }

        if (requestParameters.searchLastSeenTo !== undefined) {
            queryParameters['Search.LastSeenTo'] = (requestParameters.searchLastSeenTo as any).toISOString();
        }

        if (requestParameters.searchSeverities) {
            queryParameters['Search.Severities'] = requestParameters.searchSeverities;
        }

        if (requestParameters.searchSearchValue !== undefined) {
            queryParameters['Search.SearchValue'] = requestParameters.searchSearchValue;
        }

        if (requestParameters.searchStructuralDataFilters) {
            queryParameters['Search.StructuralDataFilters'] = requestParameters.searchStructuralDataFilters;
        }

        if (requestParameters.apiKey !== undefined) {
            queryParameters['ApiKey'] = requestParameters.apiKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Flats/starred`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogOverviewDtoGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsStarredGet(requestParameters: ApiFlatsStarredGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogOverviewDtoGenericApiResponse> {
        const response = await this.apiFlatsStarredGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiFlatsStarredPutRaw(requestParameters: ApiFlatsStarredPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Flats/starred`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StarFlatRequestToJSON(requestParameters.starFlatRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiFlatsStarredPut(requestParameters: ApiFlatsStarredPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiFlatsStarredPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
